import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParameterService } from '@app/@shared/services/api/parameter.service';
import { I18nService } from '@app/i18n';

@Component({
  selector: 'app-handler-redirect-to-language',
  templateUrl: './handler-redirect-to-language.component.html',
  styleUrls: ['./handler-redirect-to-language.component.scss'],
})
export class HandlerRedirectToLanguageComponent {
  phoneNumber: string = "";
  whatsappMessage: string = 'Hola, quiero saber más sobre inviertis ...';

  constructor(
    public _parameterService: ParameterService,
    private readonly activatedRouter: ActivatedRoute,
    private readonly router: Router,
    private readonly i18nService: I18nService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.activatedRouter.params.subscribe((params) => {
      const lang = params['lang'];
      if (lang) {
        const minLanguages = this.i18nService.supportedLanguages.map(
          (langItem: { minLag: string }) => langItem.minLag
        );
        if (minLanguages.includes(lang)) {
          this.i18nService.language = lang;
        }
      } else {
        this.i18nService.language = 'es';
      }
      this.i18nService.hasResolvedFromUrl = true;
    });
  }

  ngOnInit(): void {
    const query = {
      group_id: 2,
      sequence_id: 1,
    };
    this._parameterService.getFilters(query).subscribe((data) => {
      const filter = data.body[0];
      this.phoneNumber = filter.parameter_value;
      // this.whatsappMessage = `Hola, quiero saber más sobre inviertis (${this.i18nService.language})`;
      this.whatsappMessage = `Hola, quiero saber más sobre inviertis`;
    });
  }

  get whatsappButtonIsVisible(): boolean {
    return !this.router.url.includes('vende');
  }

  get whatsappUrl(): string {
    if (!this.phoneNumber) return '#';
    const base = 'https://wa.me/';
    const phone = this.phoneNumber.replace(/\s+/g, '');
    const message = encodeURIComponent(this.whatsappMessage);
    return `${base}${phone}?text=${message}`;
  }
}
